// Cinematic "REC •••" loader — light, only shown while genuinely loading.
export const RecLoader = ({ label = "Chargement" }) => (
  <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="rec-loader">
    <div className="flex items-center gap-3">
      <span className="relative flex h-3.5 w-3.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-70 animate-ping" />
        <span className="relative inline-flex h-3.5 w-3.5 rounded-full bg-red-500" />
      </span>
      <span className="text-[13px] tracking-[0.35em] uppercase text-white/90 font-semibold">REC</span>
      <span className="flex gap-1">
        {[0, 1, 2].map((i) => (
          <span key={i} className="h-1.5 w-1.5 rounded-full bg-electric" style={{ animation: "recDot 1.2s ease-in-out infinite", animationDelay: `${i * 0.2}s` }} />
        ))}
      </span>
    </div>
    <style>{`@keyframes recDot{0%,60%,100%{opacity:.2;transform:translateY(0)}30%{opacity:1;transform:translateY(-3px)}}`}</style>
    <span className="sr-only">{label}</span>
  </div>
);

// Clean error state with retry — never leaves REC spinning forever.
export const LoadError = ({ onRetry }) => (
  <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="load-error">
    <div className="text-center max-w-md">
      <div className="text-[11px] tracking-[0.35em] uppercase text-red-400 mb-4">Coupez !</div>
      <h1 className="font-serif text-3xl md:text-4xl text-white mb-4">Impossible de charger le contenu</h1>
      <p className="text-secondary2 font-light mb-8">Une erreur est survenue. Vérifiez votre connexion et réessayez.</p>
      <button onClick={onRetry} data-testid="load-error-retry" className="inline-flex px-7 py-3 rounded-full bg-electric text-black text-[12px] tracking-[0.12em] uppercase font-semibold hover:bg-white transition-colors">Réessayer</button>
    </div>
  </div>
);
